import { APPOINTMENT_API_BASE_URL, PATIENT_API_BASE_URL, APPOINTMENT_ANONYMOUS_ENDPOINT_SUFFIX } from '../config/api-endpoints'
import { authorizeHeader } from '../utils/auth-header'
import AuthService from '../services/AuthService'
import AuthGuestLoggedin from '../services/AuthGuestLoggedinService'

// eslint-disable-next-line import/prefer-default-export
export const getAppointmentListAPICall = async (option) => {
  const auth = new AuthService()
  const profile = auth.getUserProfile()
  const { guid } = profile

  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = `${APPOINTMENT_API_BASE_URL}?limit=${20}&offset=${0}&option=${option}&patient_guid=${guid}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw Error(`Response is not a JSON.`);
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    return e
  }
}

export const getAppointmentDetailAPICall = async (appointmentId) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = APPOINTMENT_API_BASE_URL + appointmentId
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw Error(`Response is not a JSON.`);
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    return e
  }
}

export const postAppointmentAPICall = async (body) => {

  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }
    const endpointToHit = APPOINTMENT_API_BASE_URL
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseOk = await response.status === 200 || await response.status === 201
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    return e
  }
}

export const postAppointmentAnonymousAPICall = async (body) => {

  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }
    const endpointToHit = PATIENT_API_BASE_URL + body.patients_ref + APPOINTMENT_ANONYMOUS_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, config)
    const responseOk = await response.status === 200 || await response.status === 201
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    return e
  }
}

